import NextLink from 'next/link';

import { InfoBlock } from './InfoBlock';

export const GiftCards = () => (
  <InfoBlock>
    <NextLink href="/gift-cards">Gift cards available here</NextLink>
  </InfoBlock>
);
